import { DateAdapter } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { CustomSnackbarComponent } from './components/custom-snackbar/custom-snackbar.component';
import { MaterialModule } from './material.module';
import { LoaderComponent } from './components/loader/loader.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { ListDialogComponent } from './components/list-dialog/list-dialog.component';
import { UppercaseFirstLetterPipe } from './pipes/uppercasefirstletter.pipe';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { FileUploadDialogComponent } from './components/file-upload-dialog/file-upload-dialog.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { Nl2BrPipe } from './pipes/nl2br.pipe';

@NgModule({
  declarations: [
    CustomSnackbarComponent,
    LoaderComponent,
    DialogComponent,
    ListDialogComponent,
    UppercaseFirstLetterPipe,
    ClickOutsideDirective,
    FileUploadDialogComponent,
    Nl2BrPipe,
  ],
  providers: [
    Nl2BrPipe,
  ],
  imports: [
    // Angular
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    // Angular Material
    MaterialModule,
    // Misc
    TranslateModule,
    NgxFileDropModule,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    // Angular Material
    MaterialModule,
    // Misc
    TranslateModule,

    // Custom Components
    LoaderComponent,
    UppercaseFirstLetterPipe,
    Nl2BrPipe,
    ClickOutsideDirective,
    NgxFileDropModule,
  ],
})
export class SharedModule {
  public constructor(private dateAdapter: DateAdapter<any>) {
    this.dateAdapter.setLocale('fr');
  }
}

